import cn from 'classnames/bind';
import { parseAsInteger, useQueryStates } from 'nuqs';
import React, { useState, useTransition } from 'react';

import { PriceModes } from '@/types/used-cars/used-cars.types';

import { Finance } from '../../price-finance/components/finance/finance';
import { NewFilter } from '../new-filter/new-filter';
import { useClearSearch } from '../utils';

import { Price } from './components/price/price';
import styles from './new-prices.module.scss';

const cx = cn.bind(styles);

export interface NewPricesProps {
  maxPrice: number;
  count: number;
}

export const NewPrices: React.FC<NewPricesProps> = ({ maxPrice, count }) => {
  const [_, startTransition] = useTransition();

  const [queryPriceRange, setQueryPriceRange] = useQueryStates(
    {
      pricefrom: parseAsInteger.withDefault(0),
      priceto: parseAsInteger.withDefault(maxPrice),
    },
    {
      clearOnDefault: true,
      history: 'replace',
      throttleMs: 300,
      startTransition,
      shallow: false,
    },
  );

  const [mode, setMode] = useState<PriceModes>(PriceModes.price);

  const clearSearch = useClearSearch();

  return (
    <NewFilter
      label="Price"
      count={count}
      onClear={() => setQueryPriceRange(null)}
    >
      <div className={styles.priceFinanceWrapper}>
        <div className={styles.priceFinanceTabsWrapper}>
          <div
            onClick={() => setMode(PriceModes.price)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive: mode === PriceModes.price,
            })}
          >
            Price
          </div>
          <div
            onClick={() => setMode(PriceModes.finance)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive: mode === PriceModes.finance,
            })}
          >
            Finance
          </div>
        </div>
        {mode === PriceModes.price && (
          <Price
            defaultPriceFilter={{ min: 0, max: maxPrice }}
            onChange={(val) => {
              clearSearch();

              setQueryPriceRange({
                pricefrom: val.min,
                priceto: val.max,
              });
            }}
            currentFilter={{
              min: queryPriceRange.pricefrom,
              max: queryPriceRange.priceto,
            }}
          />
        )}
        {mode === PriceModes.finance && (
          <Finance
            initialDefaultPriceFilter={{ min: 0, max: maxPrice }}
            onSetFilter={(val) => {
              clearSearch();

              setQueryPriceRange({
                pricefrom: val.min,
                priceto: val.max,
              });
            }}
          />
        )}
      </div>
    </NewFilter>
  );
};
